import ReactDOM from "react-dom/client";
import "x-wings/index.css";
import App from "./App";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { initMixpanel } from "utils/mixpanel";

initMixpanel();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//
reportWebVitals();

